import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {VerticalVideoAccountNameProps} from './vertical-video-account-name.types';
import styles from './vertical-video-account-name.module.scss';

export function VerticalVideoAccountName({accountName}: VerticalVideoAccountNameProps): ReactElement {
  return <Text bold className={styles.verticalVideoAccountName} size={TextSize.XS} val={accountName} />;
}
